import { render } from "./Form.vue?vue&type=template&id=6c84db8a"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"
script.render = render

export default script